import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import EditableTextField from '@/components/Lead/EditableTextField';
import PhoneNumberFormat from '@/components/format/PhoneNumberFormat';

import styles from './index.less';
import classNames from 'classnames';
import { getSeparateProjectContact } from '@/utils/contacts';

// The project's primary contact when it has its own; it's edited on that contact, not here.
export const getLeadPhone = (lead: LeadModel) => {
  const projectContact = getSeparateProjectContact(lead);
  return projectContact ? projectContact.phone : lead?.customer?.phone;
};

const LeadPhone = ({
  lead,
  readonly,
  isTable,
}: {
  lead: LeadModel;
  readonly: boolean;
  isTable: boolean;
  showOnePhone?: boolean;
}) => {
  const phone = getLeadPhone(lead);

  return (
    <EditableTextField
      className={classNames(styles.leadPhone, {
        [styles.leadPhoneTable]: isTable,
      })}
      isTable={isTable}
      editable={!readonly && !getSeparateProjectContact(lead)}
      lead={lead}
      property={'customer.phone'}
    >
      <PhoneNumberFormat phoneNumber={phone} variant="link" />
    </EditableTextField>
  );
};

export default LeadPhone;
